import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const SoParametersPageRBAC = {
  pageID: '526e09ec35d7bbdd640efdf20fb266c1',
  elementID: {
    BtnDownloadCsv: '87bb69ea7229bcc8d2d1103643071e35',
  },
} as const

export const useRBACSoParametersPage = createUseRBAC(SoParametersPageRBAC.elementID)

export type UseRBACSoParametersPageType = ReturnType<typeof useRBACSoParametersPage>
